import { Component, Input, OnInit } from '@angular/core';
import { EveReportingWidget, EveReportingWidgetType } from '../../widget.component';




@Component({
  selector: 'widget-background-colour',
  templateUrl: 'widget-background-colour.component.html',
  styleUrls: ['./widget-background-colour.component.css']
})
export class WidgetBackgroundColourComponent implements OnInit {

  @Input()
  widget?: EveReportingWidget = null;


  constructor(

  ) {


  }

  ngOnInit(): void {

  }
}



